import { useRecommendations, WebRecommendation } from '../../../../lib/recommendations';
import { FourUKind } from './types';
import { FourUHeader } from './FourUHeader';
import { FourUCard } from './FourUCard';

export function FourUGrid({
  state,
  narrow,
  onPick,
}: {
  state: ReturnType<typeof useRecommendations>['state'];
  narrow: boolean;
  onPick: (message: string) => void;
}) {
  const wrapper: React.CSSProperties = {
    width: '100%',
    maxWidth: 760,
    alignSelf: 'center',
    padding: narrow ? '8px 16px 32px' : '12px 48px 32px',
    boxSizing: 'border-box',
  };
  if (state.kind === 'loading') {
    return (
      <div style={wrapper}>
        <FourUHeader />
        <div style={{ display: 'grid', gridTemplateColumns: narrow ? '1fr' : '1fr 1fr', gap: 10 }}>
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                padding: '14px 16px',
                background: 'rgba(var(--hairline-rgb),0.025)',
                border: 'none',
                borderRadius: 'var(--sym-radius-container)',
              }}
            >
              <div className="orion-shimmer" style={{ height: 13, width: '70%' }} />
              <div className="orion-shimmer" style={{ height: 9, width: '90%', marginTop: 8 }} />
              <div className="orion-shimmer" style={{ height: 9, width: '60%', marginTop: 5 }} />
            </div>
          ))}
        </div>
      </div>
    );
  }
  if (state.kind === 'error') return null;
  type Tagged = WebRecommendation & { kind: FourUKind };
  const items: Tagged[] = [
    ...(state.taskRecommendations || []).map((r) => ({ ...r, kind: 'task' as const })),
    ...(state.pulseRecommendations || []).map((r) => ({ ...r, kind: 'pulse' as const })),
  ].filter((r) => r.description && r.description.trim().length > 0);
  if (items.length === 0) return null;
  return (
    <div style={wrapper}>
      <FourUHeader />
      <div style={{ display: 'grid', gridTemplateColumns: narrow ? '1fr' : '1fr 1fr', gap: 10 }}>
        {items.slice(0, narrow ? 4 : 6).map((item, i) => (
          <FourUCard
            key={`${item.name ?? ''}-${i}`}
            item={item}
            kind={item.kind}
            onPick={() => onPick(item.description || '')}
          />
        ))}
      </div>
    </div>
  );
}
